/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRoleDto } from '../models';
// @ts-ignore
import type { PaginatedRolesResponseDto } from '../models';
// @ts-ignore
import type { RoleResponseDto } from '../models';
// @ts-ignore
import type { UpdateRoleDto } from '../models';
/**
 * RolesPermissionsApi - axios parameter creator
 * @export
 */
export const RolesPermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (businessId: number, createRoleDto: CreateRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('createRole', 'businessId', businessId)
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('createRole', 'createRoleDto', createRoleDto)
            const localVarPath = `/api/v1/businesses/{businessId}/roles`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {number} [page] Page number for pagination (1-indexed).
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (businessId: number, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('findAll', 'businessId', businessId)
            const localVarPath = `/api/v1/businesses/{businessId}/roles`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} roleId 
         * @param {UpdateRoleDto} updateRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (businessId: number, roleId: string, updateRoleDto: UpdateRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('updateRole', 'businessId', businessId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRole', 'roleId', roleId)
            // verify required parameter 'updateRoleDto' is not null or undefined
            assertParamExists('updateRole', 'updateRoleDto', updateRoleDto)
            const localVarPath = `/api/v1/businesses/{businessId}/roles/{roleId}`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesPermissionsApi - functional programming interface
 * @export
 */
export const RolesPermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesPermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(businessId: number, createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(businessId, createRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesPermissionsApi.createRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {number} [page] Page number for pagination (1-indexed).
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(businessId: number, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRolesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(businessId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesPermissionsApi.findAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} roleId 
         * @param {UpdateRoleDto} updateRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(businessId: number, roleId: string, updateRoleDto: UpdateRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(businessId, roleId, updateRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesPermissionsApi.updateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesPermissionsApi - factory interface
 * @export
 */
export const RolesPermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesPermissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(businessId: number, createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleResponseDto> {
            return localVarFp.createRole(businessId, createRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {number} [page] Page number for pagination (1-indexed).
         * @param {number} [limit] Number of items per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(businessId: number, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRolesResponseDto> {
            return localVarFp.findAll(businessId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {string} roleId 
         * @param {UpdateRoleDto} updateRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(businessId: number, roleId: string, updateRoleDto: UpdateRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleResponseDto> {
            return localVarFp.updateRole(businessId, roleId, updateRoleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesPermissionsApi - object-oriented interface
 * @export
 * @class RolesPermissionsApi
 * @extends {BaseAPI}
 */
export class RolesPermissionsApi extends BaseAPI {
    /**
     * 
     * @param {number} businessId 
     * @param {CreateRoleDto} createRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesPermissionsApi
     */
    public createRole(businessId: number, createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig) {
        return RolesPermissionsApiFp(this.configuration).createRole(businessId, createRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {number} [page] Page number for pagination (1-indexed).
     * @param {number} [limit] Number of items per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesPermissionsApi
     */
    public findAll(businessId: number, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return RolesPermissionsApiFp(this.configuration).findAll(businessId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {string} roleId 
     * @param {UpdateRoleDto} updateRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesPermissionsApi
     */
    public updateRole(businessId: number, roleId: string, updateRoleDto: UpdateRoleDto, options?: RawAxiosRequestConfig) {
        return RolesPermissionsApiFp(this.configuration).updateRole(businessId, roleId, updateRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
}

